import { router } from './index'
import API from '../services/api'
import RouteViewComponent from '../layouts/RouterBypass.vue'
import { RouteRecordRaw } from 'vue-router'

export async function injectGroupRoutes() {
  console.log('🔄 Memulai injectGroupRoutes...')

  const token = localStorage.getItem('token') || sessionStorage.getItem('token')
  if (!token) {
    console.warn('⚠️ Token tidak ditemukan, inject dibatalkan')
    return
  }

  try {
    const res = await API.get('/tree-menus', {
      headers: { Authorization: `Bearer ${token}` },
    })

    const menuGroups = res.data.data
    console.log(`📦 Data menu diterima: ${menuGroups.length} group`)

    const adminDashboard = router.getRoutes().find((r) => r.name === 'admin-dashboard')
    if (!adminDashboard) {
      console.error('❌ Route "admin-dashboard" tidak ditemukan')
      return
    }

    menuGroups.forEach((group: { slug: string; children: any[] }) => {
      const groupName = group.slug

      // Cegah duplikasi group route
      if (router.hasRoute(groupName)) {
        console.warn(`⚠️ Group route "${groupName}" sudah ada, dilewati`)
        return
      }

      const routeGroup: RouteRecordRaw = {
        name: groupName,
        path: groupName,
        component: RouteViewComponent,
        meta: { dynamic: true }, // tandai sebagai route dinamis
        children: [],
      }

      const seenChildren = new Set<string>()

      group.children?.forEach((child) => {
        if (seenChildren.has(child.slug)) {
          console.warn(`⚠️ Child "${child.slug}" duplikat, dilewati`)
          return
        }
        seenChildren.add(child.slug)

        routeGroup.children!.push({
          name: child.slug,
          path: child.slug,
          component: () => import(`../pages/${child.folder}/${child.folder_2}/${child.component}.vue`),
          meta: { requiresAuth: true, dynamic: true },
        })

        console.log(`✅ Child route ditambahkan: ${group.slug}/${child.slug}`)
      })

      router.addRoute('admin-dashboard', routeGroup)
      console.log(`📁 Group route ditambahkan: ${group.slug}`)
    })

    localStorage.setItem('routesInjected', 'true')
    sessionStorage.setItem('routesInjected', 'true')
    console.log('✅ injectGroupRoutes selesai')
  } catch (err) {
    console.error('❌ Gagal inject route dinamis:', err)
  }
}

export function resetDynamicRoutes() {
  router.getRoutes().forEach((route) => {
    if (route.meta?.dynamic && route.name) {
      router.removeRoute(route.name)
    }
  })
}
